import * as React from 'react';
import { runwayColors } from './styles/globalStyles';
import { useSidebarColors } from './styles/themeMode';

export const StatusNodeDot: React.FC<{
    statusColor: string;
    halfFilled?: boolean;
    innerFilled?: boolean;
    outerBorderColor?: string;
    size?: number;
    outerBorderWidth?: number;
}> = ({ statusColor, halfFilled, innerFilled, outerBorderColor, size = 16, outerBorderWidth = 2 }) => {
    let background;

    if (halfFilled) {
        background = `linear-gradient(to right, ${statusColor} 50%, ${runwayColors.white} 50%)`;
    } else if (innerFilled) {
        background = `radial-gradient(circle, ${statusColor} 40%, ${runwayColors.white} 40%)`;
    } else if (statusColor === 'transparent') {
        background = 'transparent';
    } else {
        background = statusColor;
    }

    return (
        <div
            style={{
                borderColor: outerBorderColor ?? runwayColors.darkGrey,
                borderWidth: outerBorderWidth,
                borderStyle: 'solid',
                width: size,
                height: size,
                borderRadius: '50%',
                background,
            }}
        />
    );
};

interface StatusNodeProps {
    statusColor: string;
    showHead?: boolean;
    showTail?: boolean;
    hideConnector?: boolean;
    halfFilled?: boolean;
    innerFilled?: boolean;
    outerBorderColor?: string;
    shouldShowMiniVersion?: boolean;
    size?: number;
    outerBorderWidth?: number;
}

export const StatusNode = (props: StatusNodeProps) => {
    const showTail = props.showTail ?? true;
    const showHead = props.showHead ?? true;
    const hideConnector = props.hideConnector ?? false;
    const sc = useSidebarColors();
    return (
        <div style={{ paddingTop: 12, paddingBottom: 12, position: 'relative' }}>
            {showHead && !hideConnector && (
                <div
                    style={{
                        position: 'absolute',
                        width: 1,
                        height: 12,
                        top: 0,
                        left: 'calc(50% - 0.5px)',
                        backgroundColor: sc.connectorBg,
                    }}
                />
            )}
            <div
                style={{
                    transform: props.shouldShowMiniVersion ? 'scale(0.7)' : 'scale(1)',
                }}
            >
                <StatusNodeDot {...props} />
            </div>
            {showTail && !hideConnector && (
                <div
                    style={{
                        position: 'absolute',
                        width: 1,
                        height: 12,
                        bottom: 0,
                        left: 'calc(50% - 0.5px)',
                        backgroundColor: sc.connectorBg,
                    }}
                />
            )}
        </div>
    );
};

export default StatusNode;
